var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"vh100 d-flex flex-column justify-content-center align-items-center",attrs:{"fluid":""}},[_c('Nuxt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }